import React from "react";
import {
  BATCH_META_FIELDS,
  MONGODB_BATCH_SLUG,
  // ICONS,
  // BATCH_META_FIELDS__COMPACT,
  // BATCH_META_FIELDS__EXPANDED,
  // SELF_PACED_BATCH_META_FIELDS,
} from "../constants";
import { Radio } from "semantic-ui-react";
// import { formatNumberWithCommas } from "../utils";
import { openLoginModal } from "../../utils";

// const getFieldsToDisplay = (courseType, expandedView = false) =>
//   courseType === 1
//     ? SELF_PACED_BATCH_META_FIELDS
//     : expandedView
//     ? BATCH_META_FIELDS__EXPANDED
//     : BATCH_META_FIELDS__COMPACT;

export default function BatchOptionCard({
  batch: b,
  courseType,
  selectedBatch,
  onSelectBatch,
  currency,
  // courseFeeType,
  isLoggedIn,
}) {
  // const [expandedView, toggleExpandedView] = useReducer(
  //   (prevValue) => !prevValue,
  //   false
  // );

  const batchLocation = b?.batch_location || {};

  return (
    <div className={`option batch-${b.batch_id}`} key={b.batch_id}>
      <div className="header">
        <div className="radio_container item__left">
          <Radio
            checked={selectedBatch === b.batch_id}
            onClick={isLoggedIn ? onSelectBatch : openLoginModal}
          />
          <span className="batch_name">
            {b?.batch_slug === MONGODB_BATCH_SLUG
              ? "MongoDB Developers Toolkit"
              : b?.batch_name}
          </span>
        </div>
        {/* {!!courseFeeType || courseType !== 1 ? (
          <div className="item__right">
            {!!courseFeeType && (
              <div className="pricing_info">
                {!!b?.promotional_fee && b?.promotional_fee !== b?.batch_fee ? (
                  <p>
                    <strike>
                      <span>{currency}</span>
                      <span>
                        {formatNumberWithCommas(b?.promotional_fee) || "NA"}
                      </span>
                    </strike>
                  </p>
                ) : null}

                <p>
                  <span>{currency}</span>
                  <span>{formatNumberWithCommas(b?.batch_fee) || "NA"}</span>
                </p>
              </div>
            )}
            {courseType !== 1 && (
              <div className="toggler" onClick={toggleExpandedView}>
                <span className="text">
                  View {expandedView ? "less" : "more"}
                </span>
                <span
                  className={`icon ${!expandedView ? "animate" : "revert"}`}
                >
                  {ICONS.chevron_up}
                </span>
              </div>
            )}
          </div>
        ) : null} */}
      </div>
      <div className="content">
        <div className="meta__grid">
          {BATCH_META_FIELDS.map(({ key, label }) => (
            <>
              {(() => {
                let value;

                if (key === "offline_course_location" && courseType === 0)
                  value = batchLocation?.city;
                else if (key === "mentors") value = b?.[key]?.join(", ");
                // else if (key === "batch_fee")
                //   value = `${currency} ${b?.batch_fee}`;
                else if (key === "start_date") {
                  value = `${b?.user_specific_batch_start_date}, ${b?.country_code}`;
                } else if (key === "reg_start_date")
                  value = b?.[key] ? b?.[key]?.split("T")[0] : null;
                else value = b?.[key];

                if (value) {
                  return (
                    <div className="item" key={key}>
                      <span className="label">{`${label}: `}</span>
                      <span className="value">{value}</span>
                    </div>
                  );
                }

                return null;
              })()}
            </>
          ))}
        </div>

        {/* for offline courses only */}
        {/* {expandedView && courseType === 0 && (
          <>
            <div className="address">
              <span className="label">Address: </span>
              <span className="value">{`${batchLocation?.address}, ${batchLocation?.landmark}, ${batchLocation?.city}, ${batchLocation?.state}`}</span>
            </div>

            <div className="get_directions_cta_container">
              <a
                target="_blank"
                href={batchLocation.google_map_url}
                rel="noreferrer"
              >
                <span>Get Directions</span>
                <span>{ICONS.chevron_right}</span>
              </a>
            </div>
          </>
        )} */}
      </div>
    </div>
  );
}
